import { Button, Popover, Form } from 'antd'
import { FC, useState } from 'react'
import { useCreateCalculationMutation } from '../../../../store/api/calculations-api'
import ClientAutocomplete from '../../../../components/form-items/client-auto-complete/client-auto-complete'
import { useCreateCalculationPositionMutation } from '../../../../store/api/calculation-positions-api'
import { message } from 'antd'

interface AddNewCalculationProps {}

const AddNewCalculation: FC<AddNewCalculationProps> = () => {
    const [create] = useCreateCalculationMutation()
    const [createPosition] = useCreateCalculationPositionMutation()
    const [form] = Form.useForm()
    const [open, setOpen] = useState(false)

    const onAdd = async (contractorDocId: string) => {
        try {
            const result = await createPosition({ data: {} })
            const positionDocId = result.data?.data.documentId
            
            const calculationData: any = {
                client: { connect: [contractorDocId] },
                calculation_positions: positionDocId ? { connect: [positionDocId] } : undefined,
            }
            
            await create({
                data: calculationData,
            }).unwrap()

            message.success('Расчет успешно создан')
            
            form.resetFields()
            setOpen(false)
        } catch (error) {
            message.error('Ошибка при создании расчета')
            console.error('Error creating calculation:', error)
        }
    }

    return (
        <Popover
            open={open}
            onOpenChange={setOpen}
            content={
                <Form form={form} layout="vertical" style={{ width: 300 }}>
                    <Form.Item>
                        <ClientAutocomplete 
                            onChange={onAdd} 
                            placeholder='Выберите или создайте клиента'
                        />
                    </Form.Item>
                </Form>
            }
            placement={'bottomLeft'}
            trigger="click"
        >
            <Button type={'primary'}>Новый расчёт</Button>
        </Popover>
    )
}

export default AddNewCalculation
